import { NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl';

import { IEventDispatcher } from '../interfaces/IEventDispatcher';
import { IListenerRegistry } from '../interfaces/IListenerRegistry';
import { IStreamingService } from '../interfaces/IStreamingService';

export class NoHubScanStrategy {
  constructor(
    private plugin: NativeQSenseControlPlugin,
    private streaming: IStreamingService,
    private listeners: IListenerRegistry,
    private events: IEventDispatcher,
  ) {}

  async start(allowed: string[]) {
    // If we're streaming and do a connect call the app will crash
    this.streaming.stop();

    this.listeners.add<string, { device: string }>('onDeviceDiscovered', (event) => {
      this.plugin.connectDevices();
    });

    this.listeners.add<string, { device: string }>('onDeviceConnected', (event) => {
      this.events.emit('deviceConnected', { macAddress: event.device });
    });

    return this.plugin.startScan({ allowedDevices: allowed });
  }

  async stop() {
    this.listeners.remove('onDeviceDiscovered');
    this.listeners.remove('onDeviceConnected');

    return this.plugin.stopScan();
  }
}

export class NoHubFileTransferStrategy {
  async upload(callback: VoidFunction) {
    return callback();
  }

  async download(callback: VoidFunction) {
    return callback();
  }
}

export class NoHubConnectionStrategy {
  constructor(private plugin: NativeQSenseControlPlugin) {}

  async connect(callback: VoidFunction) {
    await this.plugin.connectDevices();
    return callback();
  }

  disconnect() {
    return this.plugin.disConnectDevices();
  }
}
